<script setup lang="ts">
import { ref, watchEffect } from 'vue'

import {
  CollapsibleContent,
  CollapsibleRoot,
  CollapsibleTrigger,
} from '@fondof-ui/components/collapsible'
import { useIsScreenMd } from '@shared/fondof-fn/media-query/screen'

const props = defineProps<{
  disabled?: boolean
}>()

const isDesktop = useIsScreenMd()
const isCollapsibleOpen = ref<boolean>(props.disabled ? true : isDesktop.value)

const isCollapseDisabled = ref<boolean>(isDesktop.value || props.disabled)

watchEffect(() => {
  isCollapsibleOpen.value = props.disabled ? true : isDesktop.value
  isCollapseDisabled.value = isDesktop.value || props.disabled
})
</script>
<template>
  <CollapsibleRoot
    :class="[
      'group w-full min-w-[15.375rem] data-[size=large]:min-w-[28.625rem] md:w-fit',
      {
        'mb-4 md:mb-0': !isCollapsibleOpen,
      },
    ]"
    :open="isCollapsibleOpen"
    :disabled="isCollapseDisabled"
    @update:open="
      (state) => {
        isCollapsibleOpen = state
      }
    "
  >
    <CollapsibleTrigger
      v-if="$slots.headline"
      class="w-full"
    >
      <slot
        name="headline"
        :disabled="isCollapseDisabled"
      />
    </CollapsibleTrigger>
    <CollapsibleContent
      v-if="$slots.content"
      class="mb-15 md:mb-0"
    >
      <slot name="content" />
    </CollapsibleContent>
  </CollapsibleRoot>
</template>
